import clearCookie from './clearCookie';

export default clearCookie;
